export const member_columns = [
  {
    name: "ID",
    width: "5%",
    align: "left",
  },
  {
    name: "Member",
    width: "20%",
    align: "left",
  },
  {
    name: "GENDER",
    width: "10%",
    align: "left",
  },
  {
    name: "DATE OF BIRTH",
    width: "15%",
    align: "left",
  },
  {
    name: "LEVEL",
    width: "15%",
    align: "center",
  },
  {
    name: "PROGRAM",
    width: "15%",
    align: "left",
  },
  {
    name: "ACTION",
    width: "20%",
    align: "left",
  },
];
